import { Auth, onIdTokenChanged, User } from 'firebase/auth';
import { Observable } from 'rxjs';

/**
 * Observable of the signed-in user. Emits on sign-in, sign-out, and token refresh.
 */
export function user(auth: Auth): Observable<User | null> {
	return new Observable((subscriber) => {
		const unsubscribe = onIdTokenChanged(
			auth,
			subscriber.next.bind(subscriber),
			subscriber.error.bind(subscriber),
		);
		return { unsubscribe };
	});
}
